import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';
import Cookies from 'js-cookie';
import headerImage from 'src/assets/images/header-image.jpg';
import { get } from 'lodash';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import AiVideo from 'src/components/player/AiVideo';
import ThinkskillVideo from 'src/assets/images/Thinkskill-intro-video.mp4';
import { base_route_url } from 'src/utils';
import { setGlobalCompare } from 'src/layouts/main/MainLayoutSlice';
import { addCareerHistory, getCareerHistory } from '../CareerHistory/CareerHistorySlice';

export default function HomePage() {
  const token = Cookies.get('feToken');
  const params = useParams();
  const clgDetails = useSelector((state) => state.mainLayout.collegeDetails);
  useEffect(() => {
    if (params) {
      Cookies.set('url-slug', params?.cg_name);
    }
  }, [params]);
  const theme = useTheme();
  const isRegionData = !!clgDetails?.region;
  const buttonColor = isRegionData ? clgDetails?.region?.button?.bgColor : '';
  const buttonFontColor = isRegionData ? clgDetails?.region?.button?.color : '';
  const fontColor = isRegionData ? clgDetails?.region?.fontColor : '';
  const bgImage = isRegionData ? clgDetails?.region?.bgImage : '';
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    Cookies.remove('feToken');
    navigate(`/college/${params?.cg_name}`);
  };
  useEffect(() => {
    const payload = {
      isRegion: false,
      collegeId: clgDetails?._id,
    };
    if (token) {
      dispatch(getCareerHistory(payload)).then((response) => {
        if (get(response, 'payload.data.currentCareerIds')) {
          const formattedData = get(response, 'payload.data.currentCareerIds')?.map((career) => ({
            label: career?.title,
            value: career?._id,
          }));
          dispatch(addCareerHistory(formattedData));
        }
        if (get(response, 'payload.data.compareCareerIds')) {
          const formattedData = get(response, 'payload.data.compareCareerIds')?.map(
            (career) => career?._id
          );
          dispatch(setGlobalCompare(formattedData));
        }
        if (get(response, 'payload.success') || get(response, 'payload.response.data.success')) {
          navigate(`${base_route_url}${params?.cg_name}/reskill/skilldar`);
        } else {
          // set career id's
          navigate(`${base_route_url}${params?.cg_name}/career-history`);
        }
      });
    }
  }, [token, clgDetails?._id, params?.cg_name, dispatch, navigate]);
  return (
    <>
      <Helmet>
        <title>ThinkSkill - Home</title>
      </Helmet>
      <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
        <img
          src={headerImage}
          alt="Region Logo"
          style={{ objectFit: 'contain', borderRadius: 8, background: '#fff' }}
        />
      </Box>
      <Box
        className="page-content-wrapper home"
        sx={{
          width: '100%',
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          py: 4,
        }}
      >
        {clgDetails ? (
          <Container maxWidth="xl">
            
            <Box pb={5} display="flex" flexDirection="column" alignItems="center">
              <Typography
                variant="h1"
                sx={{
                  fontSize: '2.75rem !important',
                  fontFamily: '"Merriweather", serif',
                  fontWeight: 900,
                  color: fontColor,
                  mt: 2,
                  textAlign: 'center',
                }}
              >
                <b>Welcome to ThinkSkills</b>
              </Typography>
              <Typography
              variant='h2'
                sx={{
                  mb: 4,
                  color: fontColor,
                  fontSize: '18px !important',
                  fontWeight: 700,
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Your future, your skills, your Worcestershire.
              </Typography>
              <Typography sx={{ mb: 2, color: fontColor }} component="p">
                Whether you're exploring your next career move or strengthening your workforce,
                ThinkSkills helps people and businesses discover skills, unlock opportunities, and
                connect with local training providers for the future of work.
              </Typography>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '12px',
                  p: 4,
                  mt: 4,
                  mb: 4,
                  maxWidth: '650px',
                  width: '100%',
                  textAlign: 'center',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: '2rem !important',
                    fontWeight: 'bold',
                    mb: 3,
                    color: '#333',
                  }}
                >
                  Get started!
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        textAlign: 'center',
                        mb: 2,
                        px: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        height: '100%',
                        pb: 2,
                      }}
                    >
                      <Typography sx={{ mb: 2, color: '#666', fontSize: '10px' }}>
                        New here? No problem! Click the button below to get moving.
                      </Typography>
                      <Button
                        component={Link}
                        to={`/${params?.cg_name}/career-history`}
                        variant="contained"
                        sx={{
                          backgroundColor: buttonColor,
                          color: buttonFontColor,
                          borderRadius: '8px',
                          px: 4,
                          py: 1,
                          fontWeight: 'bold',
                          '&:hover': {
                            backgroundColor: buttonColor,
                            opacity: 0.9,
                          },
                        }}
                      >
                        Get Started
                      </Button>
                    </Box>
                  </Grid>
                  
                </Grid>
              </Box>

              <Box
                sx={{
                  maxWidth: '1000px',
                  width: '100%',
                  mt: 4,
                }}
              >
                <AiVideo
                  width="800px"
                  height="450px"
                  url={ThinkskillVideo}
                  secondaryColor={theme.palette.secondary.main}
                />
              </Box>
            </Box>
          </Container>
        ) : (
          <Box sx={{ position: 'absolute', top: '42%', left: '48%' }}>
            <CircularProgress />
          </Box>
        )}
      </Box>
    </>
  );
}
